import { BREADCRUMB_DIRECTIVES } from '@alfresco/adf-content-services';
import { CoreModule } from '@alfresco/adf-core';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { WkBreadCrumbComponent } from './wk-breadcrumb.component';

@NgModule({
  imports: [...BREADCRUMB_DIRECTIVES, CommonModule, CoreModule],
  declarations: [WkBreadCrumbComponent],
  exports: [WkBreadCrumbComponent],
})
export class WkBreadCrumbModule {}
